import React from 'react';
import type { ValidationError } from '@wix/form-validator';
import { type Form } from '@wix/ambassador-forms-v4-form/types';
import { FormField } from './form-field';
import type {
  FormView,
  FormValues,
  InputElement,
  OnFieldChange,
  FormFields,
} from '../../types';
import { type FieldLayoutComponent } from '../../../../field-layout';
import { FormContext } from '../../../../contexts/form-context';
import {
  FieldValidationContext,
  type ValidateFields,
} from '../../../../contexts/field-validation-context';
import { FormFieldsContext } from '../../contexts/form-fields-context';
import {
  type FieldActions,
  FieldActionsContext,
  type FieldActionsContextValue,
} from '../../../../contexts/field-actions-context';
import { FormViewContext } from '../../../../contexts/form-view-context';

export interface CreateFormFieldsParams {
  form: FormView;
  errors: ValidationError[];
  values: FormValues;
  onFieldChange: OnFieldChange;
  FieldLayout: FieldLayoutComponent;
  formSchema: Form;
  validateFields: ValidateFields;
  fields: FormFields;
  fieldActions: FieldActionsContextValue<FieldActions>;
}

export const createFormFields = ({
  form,
  errors,
  values,
  onFieldChange,
  FieldLayout,
  formSchema,
  validateFields,
  fields,
  fieldActions,
}: CreateFormFieldsParams): InputElement[] => {
  return form.fields
    .map((formField) => {
      const component = (
        <FormContext.Provider value={formSchema}>
          <FormFieldsContext.Provider value={fields}>
            <FieldActionsContext.Provider value={fieldActions}>
              <FieldValidationContext.Provider value={{ validateFields }}>
                <FormViewContext.Provider value={form}>
                  <FormField
                    key={formField.id}
                    field={formField}
                    values={values}
                    errors={errors}
                    onFieldChange={onFieldChange}
                    FieldLayout={FieldLayout}
                  />
                </FormViewContext.Provider>
              </FieldValidationContext.Provider>
            </FieldActionsContext.Provider>
          </FormFieldsContext.Provider>
        </FormContext.Provider>
      );

      return {
        id: formField.id,
        fieldType: formField.fieldType,
        component,
        layout: formField.layout,
      };
    })
    .filter((item) => !!item) as InputElement[];
};
